import base from './base';
export default Object.assign(Object.assign({}, base), { name: 'Acura', heroTitleColour: 'blue', heroTitleFontSize: '60px', heroBodyColour: '#333' });
